import { useEffect, useState } from 'react'
import { isEmpty } from 'lodash'

import type { KeyMetric as KeyMetricType } from 'types/KeyMetric'
import { prepareFilters } from 'api/ApiActions/Reporting/Overview/PrepareFilters'
import keyMetricsApi from 'api/ApiActions/Reporting/Overview/KeyMetrics'
import usePrevious from 'lib/hooks/UsePrevious'
import { useAppSelector } from 'redux/Hook'
import { filterValues } from 'containers/Reporting/Shared/Helper'
interface KeyMetricsData {
  keyMetrics: KeyMetricType[]
  isKeyMetricsLoading: boolean
}

const useKeyMetricsDetails = (): KeyMetricsData => {
  const [isKeyMetricsLoading, setKeyMetricsLoader] = useState<boolean>(true)
  const [keyMetrics, setKeyMetrics] = useState<KeyMetricType[]>([])
  const {
    filterBuilder: { selectedFilters = [] } = {},
    user: { user = {} } = {},
    stakeholderDashboardDetails: { accessToken = '', password = '' },
  }: any = useAppSelector((state) => state)

  const userFilters = filterValues(selectedFilters)
  const prevProps: any = usePrevious({ userFilters })
  const fetchAndSetKeyMetrics = async () => {
    setKeyMetricsLoader(true)
    const filters = await prepareFilters(selectedFilters)

    const params = { filterParams: filters, accessToken, password }
    if (!isEmpty(userFilters)) {
      const result = await keyMetricsApi.getCardData(params)
      // reason for cheking it as a result.code was , we cant make the loader false
      //  based on empty data, as we need to show the no data case as well,
      // also we have a cancel previous api scenario
      // p.s. we need to check the generic solution for other api failure cases

      if (!['ERR_CANCELED'].includes(result?.code)) {
        setKeyMetrics(result)
        setKeyMetricsLoader(false)
      }
    }
  }

  useEffect(() => {
    const isFilterUpdated =
      !isEmpty(userFilters) &&
      JSON.stringify(prevProps?.userFilters) !== JSON.stringify(userFilters)

    if (isFilterUpdated) {
      fetchAndSetKeyMetrics()
    }
  }, [selectedFilters])

  useEffect(() => {
    fetchAndSetKeyMetrics()
  }, [user.adminLocale])

  useEffect(() => {
    fetchAndSetKeyMetrics()
  }, [accessToken])

  return {
    keyMetrics,
    isKeyMetricsLoading,
  }
}

export default useKeyMetricsDetails
